import { Flex } from '@/components/base';
import { ScrollArea } from '@/components/shadcn/ui/scroll-area';

import SettingHeader from '../Header';
import { SettingSection } from '../SettingComponents';

export const LabsSettingBody = () => {
  return (
    <ScrollArea className="h-screen">
      <SettingHeader title="Labs" />
      <div className="flex flex-col w-full px-8">
        <SettingSection>
          <Flex a="center">
            <span className="text-sm font-semibold text-primary">No labs yet</span>
          </Flex>
          <p className="text-sm text-muted-foreground">
            Experimental features will appear here.
          </p>
        </SettingSection>
      </div>
    </ScrollArea>
  );
};
